import type { DocumentId } from "src/types";
import { rootApi } from "../rootApi";
import { getCmsUrl } from "../utils";

export const tokenApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getAvailableTokensCountByProjectDocumentId: build.query<number, DocumentId>({
            query: (projectDocumentId) => ({
                url: getCmsUrl("/api/tokens/count"),
                params: {
                    documentId: projectDocumentId,
                },
            }),
        }),
    }),
});

export const { useGetAvailableTokensCountByProjectDocumentIdQuery } = tokenApi;
